import React, { useContext, useState } from "react";
import { FormGroup, FormControl } from "react-bootstrap";

const OrderDocumentVerifiedCheckbox = ({task, settings}) => {
  return (
    <>
      <label>
        Order Verified?
        <FormControl
          style={{
            margin: "0px 18px",
            display: "inline-block",
            verticalAlign: "middle",
            width: 'auto'
          }}
          type="checkbox"
          required={true}
          value={task.cpr.order_document_verified}
          checked={task.cpr.order_document_verified}
          onChange={(e) => {
            const formData = new FormData();
            formData.append('task[id]', task.id);
            formData.append("task[status]", "closed");
            if (task.response && task.response.id) {
              formData.append("task[response_attributes[id]]", task.response.id);
            }
            if (task.response && task.response.selected_option == 'patient_requested_order'){
              formData.append("task[response_attributes[outcome]]", "agent_uploaded_referral");
              formData.append("task[response_attributes[outcome_set_by_id]]", settings.me.id);
            }
            formData.append('task[order_document_verified]', e.target.checked);
            formData.append("task[event]", "cpr_not_completed");

            formData.append(
              "task[sub_status_list_id]",
              settings.all_sub_statuses.filter(
                (obj) => obj.name == "CPR required - resume notifications"
              )[0].id
            );
            return task.formHandler(formData);
          }}
        />
      </label>
      <i>* Important - PCPs, do not check the 'ORDER DOCUMENT VERIFIED?' box. wellPORTAL will review the uploaded order and check the box if it is accurate.</i>
    </>
  )
};

export default OrderDocumentVerifiedCheckbox;
